export default {
    "chws": {
        "menu": "Diagnostics",
        "title": "CHW Supply Temperature",
        "linkTitle": "CHW Supply Temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [

                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller_1A",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller_1B",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller_2",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller_3",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller_4",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller_5",
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            },

                        ],
                    }
                }
            ]
    },

    "chiller-performance": {
        "menu": "Diagnostics",
        "title": "Chiller Performance",
        "linkTitle": "Chiller Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Outdoor",
                                facility_name: "ES3",
                                mode: "markers",
                                name: "Temperature",
                            },
                            {
                                facility_name: "ES3",
                                name: "CHWS_Temp",
                            }

                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "ES3",
                                name: "Flow_Rate",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "ES3",
                                name: "efficiency",
                            },


                        ],
                    }
                }

            ]
    },
    "cooling-performance": {
        "menu": "Diagnostics",
        "title": "Cooling Performance",
        "linkTitle": "Cooling Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller_1A",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller_1B",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller_2",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller_3",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller_4",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller_5",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power (Chiller only) ",
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller_1A",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Elect-Load",
                            },
                            {
                                equipment_name: "Chiller_2",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Elect-Load",
                            },
                            {
                                equipment_name: "Chiller_3",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Elect-Load",
                            },
                            {
                                equipment_name: "Chiller_4",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Elect-Load",
                            },
                            {
                                equipment_name: "Chiller_5",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Elect-Load",
                            },
                            {
                                equipment_name: "Chiller_1B",
                                facility_name: "ES3",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Elect-Load",
                            },


                        ],
                    }
                },



            ]
    },


};
